import { createQuery } from '@tanstack/svelte-query';
import { fetchProjects } from '$lib/api/project';
import type { Project } from '$lib/types/project';

export const projectsQueryKey = ['projects'] as const;

export function projectsQueryOptions() {
	return {
		queryKey: projectsQueryKey,
		queryFn: () => fetchProjects()
	};
}

export const projectsQuery = () => createQuery<Array<Project>>(() => projectsQueryOptions());
